import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const StaticPage = ({ title, content }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
      <div className="container mx-auto px-4 py-12">
        <Link to="/" className="text-purple-600 hover:text-purple-700 mb-4 inline-block">
          ← Back to Home
        </Link>
        
        <h1 className="text-4xl font-bold mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
          {title}
        </h1>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-4xl">
          <div className="prose max-w-none">
            {content}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default StaticPage;
